import {createSelector} from 'reselect';

export const getErrorState = (state) => state.errors;

export const getErrorsForSummary = createSelector(
	getErrorState,
	(_, props) => props,
	(errors, props) => {
		let message = errors.message || (typeof errors === 'string' && errors) || undefined;
		let isRbac = false;
		let error = {};

		if (_.isArray(errors)) {
			const rbacError = _.find(errors, ({ErrorCode}) => ErrorCode === '106');

			if (rbacError) {
				isRbac = true;
				error = rbacError;
				message = rbacError.Message;
			}
		} else if (errors['RBACV2-Global']) {
			isRbac = true;
			error = errors['RBACV2-Global'];
		}
		return {
			errorMessage: message,
			isRbac: isRbac,
			error: error,
			level: errors.level || 'error'
		};
	}
);
